<template>
  <hr class="mb-[0.5lh] mt-[0.25lh]">
</template>
